import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LoadingService } from '@core/services/loading/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoadingComponent {
  readonly showLoading$ = this.loadingService.showLoading$;

  constructor(private loadingService: LoadingService, private cdr: ChangeDetectorRef) {}
}
